import React from "react";
import { connect } from "react-redux";
import { Layout, Button, Typography, Row, Col, Select, Spin, notification, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Header, InputCurrency, UserBalance } from "components";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { getUserBalanceId, userRedeem } from "services/user-service";
import { getEmployee } from "services/employee-service";
import { getAllBenefit } from "services/benefit-service";

const { Footer, Content } = Layout;
const { Text } = Typography;

const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer
});

const DataFetch = {
    data: [],
    loadingBalance: false
}

const COMPLETE = 'C';
const BENEFIT = 'B';
const PARTIAL = 'P';
const FREE = -1;

const UserRedeemScreen = (props) => {
    const { login } = props;
    const { id } = useParams();
    const location = useLocation();
    const [benefits, setBenefits] = React.useState([])
    const { benefit } = location.state || props;
    const [data, setData] = React.useState(DataFetch)
    const [saving, setSaving] = React.useState(false)
    const [showPartialRedeemModal, setShowPartialRedeemModal] = React.useState(false);
    const [balances, setBalances] = React.useState([]);
    const [amount, setAmount] = React.useState(0);
    const [benefitID, setbenefitID] = React.useState(null);
    const navigate = useNavigate();

    const loadBenefits = async () => {
        if (login.company.benefitAccount) {
            const res = await getAllBenefit(login.company.id, true);
            const benefits = res
                .filter(x => x.account != null && x.enabled)
            setBenefits(benefits);
        }
    }

    const load = async () => {
        setData((x) => ({ ...x, loadingBalance: true }));
        await loadBenefits();
        const balance = await getUserBalanceId(id);
        setBalances(balance.details.map(balance => {
            return {
                value: balance.benefit,
                label: balance.nameBenefit,
            }
        }));
        setData((x) => ({ ...x, loadingBalance: false, balance: balance }))
        const userData = await getEmployee(id);
        setData((x) => ({ ...x, user: userData }))
    }

    React.useEffect(() => {
        load();
    }, [])

    const calcFee = (percentage, amount) => {
        return (percentage / 100) * amount;
    }

    const computeFeeBreakdown = (value, lastWeekCharge, feePercentage) => {
        const exemptAmount = Math.min(lastWeekCharge || 0, value || 0);
        const feeableAmount = Math.max((value || 0) - exemptAmount, 0);
        const fee = feePercentage ? calcFee(feePercentage, feeableAmount) : 0;
        return { exemptAmount, feeableAmount, fee };
    };

    const onRedeem = (type) => {
        let text = 'Após a confirmação, o saldo  do participante será resgatado.';
        const feePercentage = login.company?.dischargeFee;
        let value = 0;
        let lastWeekChargeSum = 0;

        if (type === COMPLETE) {
            text = 'Após confirmação, o saldo de todas as segmentações do participante será resgatado, zerando a conta do participante.'
            value = data.balance.balance;
            lastWeekChargeSum = (data.balance.details || []).reduce(
                (acc, detail) => acc + Math.min(detail.lastWeekCharge || 0, detail.balance || 0),
                0
            );
        } else if (type === BENEFIT) {
            text = 'Após confirmação, o saldo de todas as segmentações, exceto o saldo Livre, será resgatado.'
            const eligibleDetails = data.balance.details.filter(detail => detail.benefit != FREE);
            value = eligibleDetails.reduce((acc, detail) => acc + detail.balance, 0);
            lastWeekChargeSum = eligibleDetails.reduce(
                (acc, detail) => acc + Math.min(detail.lastWeekCharge || 0, detail.balance || 0),
                0
            );
        }

        const { fee } = computeFeeBreakdown(value, lastWeekChargeSum, feePercentage);
        const currencyOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

        Modal.confirm({
            title: 'Deseja continuar?',
            icon: <InfoCircleOutlined />,
            content: (
                <>
                    {text}
                    {fee > 0 && !login.company?.master && (
                        <>
                            <br />
                            <br />
                            Taxa:  R$ {fee.toLocaleString('pt-BR', currencyOptions)}<br />
                            Valor resgatado: R$ {(value - fee).toLocaleString('pt-BR', currencyOptions)}
                        </>
                    )}
                </>
            ),
            onOk: async () => {
                redeem(type)
            },
            onCancel() {
            },
        });
    }

    const redeem = async (type) => {
        setSaving(true)
        try {
            let res = await userRedeem(id, type, benefit)
            if (res.success) {
                notification.success({ message: `Saldo resgatado! No próximo pedido você pode usar ele como crédito.` });
                load();
            }
        } finally {
            setSaving(false)
        }
    }

    const getSelectedDetail = () => {
        return data.balance?.details?.find(detail => detail.benefit === benefitID) || null;
    }

    const handlePartialRedeemFee = () => {
        const text = 'Após a confirmação, o saldo do participante será resgatado.';
        const feePercentage = login.company?.dischargeFee;
        const selectedDetail = getSelectedDetail();
        const { fee } = computeFeeBreakdown(amount, selectedDetail?.lastWeekCharge, feePercentage);

        if (fee <= 0) {
            handlePartialRedeem();
            return;
        }

        const currencyOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

        Modal.confirm({
            title: 'Deseja continuar?',
            icon: <InfoCircleOutlined />,
            content: (
                <>
                    {text}
                    {!login.company?.master && (
                        <>
                            <br />
                            <br />
                            Taxa:  R$ {fee.toLocaleString('pt-BR', currencyOptions)}<br />
                            Valor resgatado: R$ {(amount - fee).toLocaleString('pt-BR', currencyOptions)}
                        </>
                    )}
                </>
            ),
            onOk: async () => {
                handlePartialRedeem();
            },
            onCancel() {
            },
        });
    }

    const handlePartialRedeem = async () => {
        setSaving(true);
        try {
            const AvailableBalanceAmount = data.balance.details.find(balance => balance.benefit === benefitID)?.balance  || 0;
            if(Number(amount) > Number(AvailableBalanceAmount)) {
                notification.error({ message: 'Valor excede o saldo do participante.' });
                return;
            }

            let response = await userRedeem(id, PARTIAL, benefitID, amount);
            if (response.success) {
                notification.success({ message: `Saldo resgatado! No próximo pedido você pode usar ele como crédito.` });
                setShowPartialRedeemModal(false);
                setAmount(0);
                setbenefitID(null);
                load();
            }

        } finally {
            setSaving(false);
        }
    }

    const isPartialFeeExempt = () => {
        const feePercentage = login.company?.dischargeFee;
        const selectedDetail = getSelectedDetail();
        const { fee } = computeFeeBreakdown(amount, selectedDetail?.lastWeekCharge, feePercentage);
        return fee <= 0;
    }

    return <Layout className="alymente-layout">
        <Header title={`Resgate de Saldo` + (data.user?.name ? (" - " + data.user?.name) : "")}>
            <Row>
            </Row>
        </Header>
        <Content>
            <Row style={{ marginBottom: 40 }} justify="center">
                <UserBalance loading={data.loadingBalance} balance={data.balance} benefit={benefit} />
            </Row>
            {
                data.loadingBalance ?
                    <Row justify="center">
                        <Spin spinning={data.loadingBalance}></Spin>
                    </Row>
                    :
                    <React.Fragment>
                        <Row style={{ marginBottom: 40 }} justify="center">
                            {
                                (benefit && benefits.length > 0) &&
                                <Col sm={24} style={{ textAlign: 'center' }}>
                                    <Text>Só é possível resgatar o saldo {benefits.filter(b => b.benefit == benefit)[0].name}.</Text>
                                </Col>
                            }
                            <Col sm={24} style={{ textAlign: 'center' }}>
                                <Text>ATENÇÃO: Ao resgatar o valor de um participante, será demonstrado como saldo expirado no extrato.</Text>
                            </Col>
                        </Row>
                        <Row justify="center" style={{ marginBottom: 10 }}>
                            <Col xl={7} lg={9} md={16} sm={24} style={{ justifyContent: 'center' }}>
                                <Button disabled={saving} loading={saving} block type="primary" onClick={() => onRedeem(COMPLETE)}>Resgatar Saldo Completo</Button>
                            </Col>
                        </Row>
                        <Row justify="center" style={{ marginBottom: 10 }}>
                            <Col xl={7} lg={9} md={16} sm={24} style={{ justifyContent: 'center' }}>
                                <Button disabled={saving} loading={saving} block type="primary" onClick={() => onRedeem(BENEFIT)}>Resgatar Saldo Completo de Segmentações</Button>
                            </Col>
                        </Row>
                        <Row justify="center" >
                            <Col xl={7} lg={9} md={16} sm={24} style={{ justifyContent: 'center' }}>
                                <Button disabled={saving} loading={saving} block type="primary" onClick={() => setShowPartialRedeemModal(true)}>Resgatar Saldo Parcial</Button>
                            </Col>
                        </Row>
                    </React.Fragment>
            }
            <Modal
                title="Selecione a segmentação que deseja resgatar o saldo."
                open={showPartialRedeemModal}
                okText={'Resgatar'}
                okButtonProps={{
                    loading: saving,
                    disabled: !benefitID || amount <= 0,
                }}
                onOk={(login.company?.master || isPartialFeeExempt()) ? handlePartialRedeem : handlePartialRedeemFee}
                onCancel={() => {
                    setShowPartialRedeemModal(false);
                    setAmount(0);
                    setbenefitID(null);
                }}
            >
                <Row style={{ margin: '20px 0' }} justify="center">
                    <UserBalance loading={data.loadingBalance} balance={data.balance} benefit={benefit} />
                </Row>
                <Row justify="space-between" align="middle" style={{ margin: '10px', height: 100 }}>
                    <Select style={{
                        width: '45%',
                    }}
                        placeholder="Selecione a segmentação"
                        options={balances}
                        value={benefitID}
                        allowClear
                        onChange={(value) => {
                            setbenefitID(value);
                        }}
                    />

                    <Col style={{width: '50%'}}>
                        <InputCurrency
                            disabled={!benefitID}
                            value={amount}
                            onChange={setAmount}
                        />
                    </Col>
                </Row>
            </Modal>
        </Content>
        <Footer style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'left'
        }}>
            <Button
                className="btn-save"
                type="primary"
                onClick={() => navigate(`/user/${id}`)}>
                Voltar
            </Button>
        </Footer>
    </Layout>
}

export default connect(mapStateToProps, {})(UserRedeemScreen);